var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-button",
        {
          staticClass: "filter-item",
          attrs: { type: "primary", icon: "el-icon-plus" },
          on: { click: _vm.addFun }
        },
        [_vm._v("新增")]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.skilItemData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "180", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.row.code)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "修改", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "600px",
            visible: _vm.addItem,
            "before-close": _vm.closeDiglog,
            modal: false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addItem = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addSkillItem",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "编码：", prop: "code" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      type: "text",
                      value: "addData.code",
                      disabled: _vm.title === "修改" ? true : false
                    },
                    model: {
                      value: _vm.addData.code,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "code", $$v)
                      },
                      expression: "addData.code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "名称：", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "name", $$v)
                      },
                      expression: "addData.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "数据类型：", prop: "dataType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.addData.dataType,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "dataType", $$v)
                        },
                        expression: "addData.dataType"
                      }
                    },
                    _vm._l(_vm.dataTypeList, function(data) {
                      return _c("el-option", {
                        key: data,
                        attrs: { label: data, value: data }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "展示方式：", prop: "display" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.addData.display,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "display", $$v)
                        },
                        expression: "addData.display"
                      }
                    },
                    _vm._l(_vm.displayList, function(data) {
                      return _c("el-option", {
                        key: data.value,
                        attrs: { label: data.value, value: data.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "默认值：", prop: "value" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.value,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "value", $$v)
                      },
                      expression: "addData.value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "可选项：", prop: "option" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { type: "textarea", rows: 5 },
                    model: {
                      value: _vm.addData.option,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "option", $$v)
                      },
                      expression: "addData.option"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }